import React from 'react'
import Profile from './Profile'

import MedicalStaff from '../../../models/MedicalStaff/MedicalStaff'
import { connect } from 'react-redux'
import v4 from 'uuid/v4'

function getMedicalStaff (profile) {
  const name = profile.name.toString().includes('@') ? `${(profile.user_metadata && profile.user_metadata.firstName) || 'Paulo'} ${(profile.user_metadata && profile.user_metadata.lastName) || 'Gomes'}` : profile.name
  return new MedicalStaff(
    v4(),
    name,
    profile.picture,
    profile.gender || (profile.user_metadata && profile.user_metadata.gender) || 'male',
    (profile.user_metadata && profile.user_metadata.profession) || '',
    '1234ABF331',
    (profile.user_metadata && profile.user_metadata.location) || '',
    '+55 11 2395 8400',
    '+55 923 958 400',
    profile.email
  )
}

class ProfileContainer extends React.Component {
  render () {
    const {profile} = this.props
    if (profile) {
      return <Profile medicalStaff={getMedicalStaff(profile)} />
    }
  }
}

function mapStateToProps ({auth}) {
  return {
    profile: auth.profile
  }
}

export default connect(mapStateToProps)(ProfileContainer)
